import { Component, Input, OnInit } from '@angular/core';
import { Goal2030Model, OutcomeMetricModel, ProjectLinkedOutcomeModel, ProjectModel, ProjectOutcomeModel } from '../../../../../../../hub_schema/hubTypes';

@Component({
    selector: 'app-linked-outcomes-panel',
    templateUrl: './linked-outcomes-panel.component.html',
    styleUrl: './linked-outcomes-panel.component.scss',
    standalone: false
})
export class LinkedOutcomesPanelComponent implements OnInit {
    @Input()
    public project!: ProjectModel;

    @Input()
    public goal!: Goal2030Model;

    @Input()
    public outcomeMetrics: OutcomeMetricModel[];

    public linkedOutcomes: ProjectLinkedOutcomeModel[] | undefined;

    public ngOnInit(): void {
        this.linkedOutcomes = this.project.linkedOutcomes?.filter(lo => lo.projectOutcome?.outcome?.outcomeMetric?.goal2030Id === this.goal.goal2030Id);
    }

    public displayPreferredOutcomeMetricName() {
        return this.outcomeMetrics.find(om => {
            return this.goal.goal2030Id === om.goal2030.goal2030Id;
        })?.preferredUnit?.name;
    }

    public displayProgress(linkedOutcome) {
        let progress = linkedOutcome.projectOutcome.outcomeStatistics.totalProgress;
        if (linkedOutcome.projectOutcome.outcome.outcomeUnit?.outcomeUnitId !== linkedOutcome.projectOutcome.outcome.outcomeMetric.preferredUnitId) {
            var unitConversion = linkedOutcome.projectOutcome.outcome.outcomeUnit.unitConversions.find(
                ouc =>
                    ouc.sourceUnitId === linkedOutcome.projectOutcome.outcome.outcomeMetric.preferredUnitId &&
                    ouc.targetUnitId === linkedOutcome.projectOutcome.outcome.outcomeUnit?.outcomeUnitId
            );
            progress = progress / unitConversion.conversion;
        }
        return progress;
    }

    public displayPreferredName(linkedOutcome) {
        return linkedOutcome.projectOutcome.outcome?.outcomeMetric?.preferredUnit?.name;
    }

    public getGoalClass(goalName: string): string {
        if (goalName === 'Climate Mitigation') {
            return 'climate-mitigation';
        } else if (goalName === 'Climate Adaptation') {
            return 'climate-adaptation';
        } else if (goalName === 'Healthy Oceans') {
            return 'healthy-oceans';
        } else if (goalName === 'Healthy Lands') {
            return 'healthy-lands';
        } else if (goalName === 'Healthy Freshwater') {
            return 'healthy-freshwater';
        } else if (goalName === 'People') {
            return 'people';
        }
        return '';
    }
}
